module.exports = __webpack_public_path__ + "static/media/cvvlogs.2c87ad97.svg";